<template>
  <div>
    <container-headline
      :headline="$t('global.infoeventdetails')"
      :col="6"
    ></container-headline>

    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <b-form-input
                  v-model.trim="infoanlass.kontakt_email"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.contactemail") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <textarea
                  v-model.trim="infoanlass.ort"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                ></textarea>
                <label>{{ $t("global.city") }}</label>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="form-group">
                <textarea
                  v-model.trim="infoanlass.dauer"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                ></textarea>
                <label>{{ $t("global.duration") }}</label>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="form-group">
                <textarea
                  v-model.trim="infoanlass.daten"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                ></textarea>
                <label>{{ $t("global.Dates") }}</label>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="form-group">
                <textarea
                  v-model.trim="infoanlass.zeiten"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                ></textarea>
                <label>{{ $t("global.times") }}</label>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="form-group">
                <textarea
                  v-model.trim="infoanlass.treffpunkt"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                ></textarea>
                <label>{{ $t("global.meetingpoint") }}</label>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="form-group">
                <textarea
                  v-model.trim="infoanlass.kosten"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                ></textarea>
                <label>{{ $t("global.costs") }}</label>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="form-group">
                <textarea
                  v-model.trim="infoanlass.lehrmittel"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                ></textarea>
                <label>{{ $t("global.teachingmaterial") }}</label>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="form-group">
                <textarea
                  v-model.trim="infoanlass.dokumentation"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                ></textarea>
                <label>{{ $t("global.documentation") }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";

export default {
  name: "InfoanlassDetails",
  components: {
    ContainerHeadline,
  },
  props: {
    infoanlass: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss">
</style>
